import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/Logo";
import { ThemeToggle } from "../components/ThemeToggle";
import { AppFooter } from "../components/layout/AppFooter";
import { Button } from "../components/ui/button";

export const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-dvh bg-background text-foreground">
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-border bg-background px-4 sm:px-6">
      <Logo size="h-6" to="/login" />
      <div className="flex items-center gap-2">
        <ThemeToggle />
        <Button asChild variant="secondary" size="sm">
          <Link to="/login" data-testid="legal-back-link">
            <ArrowLeft className="mr-2 h-4 w-4" /> Back
          </Link>
        </Button>
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
      <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl" data-testid="legal-title">
        {title}
      </h1>
      <p className="mt-2 text-xs text-muted-foreground">Last updated {updated}</p>
      <div className="mt-8 space-y-7 text-sm leading-relaxed text-muted-foreground">{children}</div>
    </main>
    <AppFooter />
  </div>
);

export const Section = ({ heading, children }) => (
  <section className="space-y-2.5">
    <h2 className="text-base font-semibold text-foreground">{heading}</h2>
    {children}
  </section>
);
